<p>azure-oauth-response works!</p>
